<h2 mat-dialog-title>
  <ng-container i18n="@@action.settings-risk-assessment-templates.import">
    Import risk assessment template
  </ng-container>
</h2>

<mat-dialog-content>
  @if (isUploading()) {
    <app-loader containerClass="on-dialog" />
  } @else {
    <app-upload-files-box
      [footerLeftText]="uploadBoxFooterLeftText"
      [footerRightText]="uploadBoxFooterRightText"
      [maxSizeInMb]="maxSizeInMb"
      [supportedFileTypes]="supportedFileTypes"
      [validate]="true"
      [multiple]="false"
      (filesSelected)="onFileSelected($event[0].file)"
    />
  }
</mat-dialog-content>

<mat-dialog-actions>
  <app-button-group>
    <app-button (pressed)="close()" type="ghost" i18n="@@shared.cancel">Cancel</app-button>
  </app-button-group>
</mat-dialog-actions>
